export default __webpack_public_path__ + "static/media/organization.076e0de5.png";